/* eslint-disable @repo/internal/react/no-unsafe-spread-props */
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import Compiled, { groupCSS as compiledGroupCSS, GroupHeading as CompiledGroupHeading, groupHeadingCSS as compiledGroupHeadingCSS } from '../compiled/components/group';
import Emotion, { groupCSS as emotionGroupCSS, GroupHeading as EmotionGroupHeading, groupHeadingCSS as emotionGroupHeadingCSS } from '../emotion/components/group';
export var groupCSS = function groupCSS(props) {
  return fg('compiled-react-select') ? compiledGroupCSS() : emotionGroupCSS(props);
};
var Group = function Group(props) {
  return fg('compiled-react-select') ? /*#__PURE__*/React.createElement(Compiled, props) : /*#__PURE__*/React.createElement(Emotion, props);
};
export var groupHeadingCSS = function groupHeadingCSS(props) {
  return fg('compiled-react-select') ? compiledGroupHeadingCSS() : emotionGroupHeadingCSS(props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var GroupHeading = function GroupHeading(props) {
  return fg('compiled-react-select') ? /*#__PURE__*/React.createElement(CompiledGroupHeading, props) : /*#__PURE__*/React.createElement(EmotionGroupHeading, props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Group;